module.exports = __webpack_public_path__ + "img/topic.fac2127f.png";